import React, { useEffect, useState, useMemo } from 'react';
import { useAppSelector } from '../../app/store';
import Sidebar from './Sidebar';
import AppRoutes from '../../router';

function tsToMs(ts: bigint): number {
  const n = Number(ts);
  return n > 1e15 ? n / 1000 : n;
}

export default function AdminShell() {
  const { connectionStatus, adminIdentity } = useAppSelector(s => s.admin);
  const users = useAppSelector(s => s.data.users);
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setCurrentTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const onlineCount = useMemo(() => {
    const fiveMinAgo = currentTime.getTime() - 5 * 60 * 1000;
    return users.filter(u => tsToMs(u.lastActiveAt) > fiveMinAgo).length;
  }, [users, currentTime]);

  const statusDotClass = `status-dot status-dot--${connectionStatus}`;

  return (
    <div className="admin-desktop">
      {/* Top bar */}
      <div className="admin-topbar">
        <div className="admin-topbar__title">
          <span>Sweepr Admin</span>
        </div>
        <div className="admin-topbar__status">
          <span className={statusDotClass} title={connectionStatus} />
          <span>{connectionStatus}</span>
          {adminIdentity && (
            <span className="admin-topbar__identity" title={adminIdentity}>
              {adminIdentity.slice(0, 12)}...
            </span>
          )}
        </div>
      </div>

      {/* Main layout */}
      <div className="admin-layout">
        <Sidebar />
        <div className="admin-content">
          <AppRoutes />
        </div>
      </div>

      {/* Status bar */}
      <div className="win-statusbar admin-statusbar">
        <div className="admin-statusbar__section">
          Users: {users.length}
        </div>
        <div className="admin-statusbar__section" style={{ color: onlineCount > 0 ? '#008000' : undefined }}>
          Online: {onlineCount}
        </div>
        <div className="admin-statusbar__section">
          {currentTime.toLocaleTimeString()}
        </div>
      </div>
    </div>
  );
}
